// Variable 'Window' is already defined in scope, but not explicitly set to type 'any'.
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- Grandfathered in
export const Windowz: any = typeof window !== 'undefined' ? (window as any) : {};
